<div class="d-flex wrapper {{styleClass}}"
    [ngClass]="{'flex-column align-items-stretch': !inline,'align-items-center': !inline}">
    <div class="d-flex align-items-center mb-3" *ngIf="label || icon" [ngClass]="{'mb-3':!inline,'me-3': inline}">
        <i class="icon {{icon}} me-2" *ngIf="icon"></i>
        <div *ngIf="label" class="font-large color-greyish">{{label | translate}}</div>
    </div>
    <div class="d-flex align-items-center" #inputContainerRef>
        <div class="input-addon" *ngIf="buttonIcon" (click)="onButtonClicked()">
            <i class="icon {{buttonIcon}} d-flex align-items-center"></i>
        </div>

        <input *ngIf="!form" class="px-3 py-2" (blur)="onBlurHandler($event)" [(ngModel)]="model" [max]="max"
            placeholder="{{placeholder | translate}}" [ngClass]="{'hasAddon': buttonIcon}" [readonly]="readonly"
            type="{{type}}" #inputRef />
        <input *ngIf="form" class="px-3 py-2" (blur)="onBlurHandler($event)" [formControl]="form" [max]="max"
            placeholder="{{placeholder | translate}}" [ngClass]="{'hasAddon': buttonIcon}" [readonly]="readonly"
            type="{{type}}" #inputRef />


        <!-- <mapfre-auditlib-button class="font-medium" *ngIf="buttonText" (click)="onButtonClicked()">
            </mapfre-auditlib-button> -->
    </div>
    <mapfre-auditlib-form-errors *ngIf="form" [form]="form" [targetRef]="inputContainerRef"
        [skipHighlighter]="skipHighlighter"></mapfre-auditlib-form-errors>
</div>